// POM-6111 — the reason an admin gives when a receipt closes part of a lot's unverified
// (negative) balance.
//
// Every code here MUST exist in core's InventoryAdjustmentReasonCode enum: the API takes it as a
// GraphQL enum, so anything else is rejected before it reaches the service. There is deliberately
// no "Other" option — this is the column the audit report groups on to answer "why was this
// allowed", and a free-text bucket defeats that. Free text still rides alongside in the notes
// field, which stays optional.
//
// Only the confirm-the-stock-is-real codes belong on this flow. A receipt IS the evidence the
// stock exists, so the write-off codes (BREAKAGE, DAMAGE, NEVER_EXISTED) would contradict the act
// of recording one; they belong on physical count, where the pharmacy learns the opposite.
const TALLY_REASON_OPTIONS = [
  { code: 'MISSED_RECEIPT', label: 'Missed receipt — record was never entered' },
  { code: 'NEW_SHIPMENT', label: 'New shipment of the same lot' },
  { code: 'COUNTED_PRESENT', label: 'Found on shelf during a count' },
  { code: 'FACILITY_TRANSFER', label: 'Transfer from another pharmacy not recorded' },
];

export default TALLY_REASON_OPTIONS;
